export class RoutesConstants {
  public static BREADCRUMB = 'breadcrumb';
  public static NAV_BAR_MENU_OPEN = 'navBarOpen';
  public static DEVICE_OS_TYPE_MAC = 'Mac';
  public static INIT_VALUE = 'Init';
  public static NOT_SUPPORTED = 'NOT_SUPPORTED';
  public static LOGIN_APP = 'CUSTOMER';

  // Navigation
  public static NAVIGATION_KEY_DASHBOARD = 'DASHBOARD';
  public static NAVIGATION_KEY_DASHBOARDS = 'DASHBOARDS';
  public static NAVIGATION_KEY_MY_DASHBOARD = 'MY_DASHBOARD';
  public static NAVIGATION_KEY_HEAT_MAP = 'HEAT_MAP';
  public static NAVIGATION_KEY_CUSTOMERS = 'CUSTOMERS';
  public static NAVIGATION_KEY_SHIPMENTS = 'SHIPMENTS';
  public static NAVIGATION_KEY_MY_SHIPMENTS = 'MY_SHIPMENTS';
  public static NAVIGATION_KEY_FLEET_PROVIDERS = 'FLEETS';
  public static NAVIGATION_KEY_MADAR_PROVIDERS = 'MADAR-PROVIDERS';
  public static NAVIGATION_KEY_FLEET_USER_DRIVERS = 'DRIVERS';
  public static NAVIGATION_KEY_FLEET_USER_TRUCKS = 'TRUCKS';
  public static NAVIGATION_KEY_FLEET_USER_RENTED_TRUCKS = 'RENTED_TRUCKS';
  public static NAVIGATION_KEY_FLEET_USER_USERS = 'USERS';
  public static NAVIGATION_KEY_CONTRACTS = 'contracts';
  public static NAVIGATION_KEY_CUSTOMER_MADAR_CONTRACTS = 'CUSTOMER_MADAR-CONTRACTS';
  public static NAVIGATION_KEY_FLEET_MADAR_CONTRACTS = 'FLEET_MADAR-CONTRACTS';
  public static NAVIGATION_KEY_CUSTOMER_FLEET_CONTRACTS = 'CUSTOMER-FLEET-CONTRACTS';
  public static NAVIGATION_KEY_MANAGE = 'MANAGE';
  public static NAVIGATION_KEY_MANAGE_BROADCAST = 'BROADCAST';
  public static NAVIGATION_KEY_MANAGE_USERS = 'USERS';
  public static NAVIGATION_KEY_PROFILE = 'PROFILE';
  public static NAVIGATION_KEY_MANAGE_LEADS = 'LEADS';
  public static NAVIGATION_KEY_LIVE_TRACKING = 'LIVE-TRACKING';
  public static NAVIGATION_KEY_FLEET_INVOICES = 'FLEET_INVOICES';
  public static NAVIGATION_KEY_MANAGE_RECEIVERS = 'RECEIVERS';
  public static NAVIGATION_KEY_REPORTS = 'REPORTS';
  public static NAVIGATION_KEY_TRUCKS_REPORTS = 'TRUCKS_REPORT';
  public static NAVIGATION_KEY_INVOICES = 'INVOICES';
  public static NAVIGATION_KEY_MANAGE_SETTINGS = 'SETTINGS';
  public static NAVIGATION_KEY_TRANSPORTATION_PAYMENT = 'TRANSPORTATION_PAYMENT';
  public static NAVIGATION_KEY_MANAGE_MY_CUSTOMERS = 'MY_CUSTOMERS';
  public static NAVIGATION_KEY_TRIP_PLANNING = 'TRIP_PLANNING';
  public static NAVIGATION_KEY_ORDERS = 'ORDERS';
  public static NAVIGATION_KEY_TRANSACTIONS = 'TRANSACTIONS';
  // Navigation path
  public static HOME_PATH = 'home';
  public static DASHBOARDS_PATH = 'dashboards';
  public static DASHBOARD_PATH = 'dashboard';
  public static MY_DASHBOARD_PATH = 'my-dashboard';
  public static CUSTOMERS_PATH = 'customers';
  public static CUSTOMER_PATH = 'customer';
  public static ADD_CUSTOMER_PATH = 'add-customer';
  public static CUSTOMER_INFO_PATH = 'customer-info';
  public static MY_WALLET_PATH = 'my-wallet';
  public static SHIPMENTS_PATH = 'shipments';
  public static VIEW_SHIPMENT_PATH = 'view-shipment';
  public static EDIT_SHIPMENT_PATH = 'edit-shipment';
  public static ADD_SHIPMENT_PATH = 'add-shipment';
  public static FLEET_PROVIDERS_PATH = 'fleets';
  public static MADAR_CONTRACTS_PATH = 'madar-contracts';
  public static CUSTOMER_FLEET_CONTRACTS_PATH = 'customer-fleet-contracts';
  public static FLEET_PROVIDER_PATH = 'fleet';
  public static FLEET_REQUEST_PATH = 'fleet-request';
  public static ADD_FLEET = 'add-fleet';
  public static VIEW_FLEET_USER_COMPANY = 'company-info';
  public static VIEW_FLEET_USER_TRUCKS = 'trucks';
  public static VIEW_FLEET_USER_DRIVERS = 'drivers';
  public static VIEW_FLEET_USER_USERS = 'users';

  public static FLEET_ADD_BULK_DRIVERS = 'add-bulk-drivers';
  public static FLEET_ADD_BULK_TRUCKS = 'add-bulk-trucks';
  public static FLEET_ADD_BULK_DRIVERS_WITH_TRUCKS = 'add-bulk-drivers-with-trucks';

  public static MANAGE_PATH = '';
  public static BROADCAST_PATH = 'broadcast';
  public static USERS_PATH = 'users';
  public static USER_PATH = 'user';
  public static ADD_USER_PATH = 'add';
  public static ALL = 'All';

  public static LOGIN_PATH = 'login';
  public static RECEIVERS_PATH = 'receivers';
  public static RECEIVER_PATH = 'receiver';
  public static ADD_RECEIVER_PATH = 'add-receiver';
  public static VIEW_EDIT_RECEIVER_PATH = 'receiver';
  public static ADD_DRIVER = 'add-driver';
  public static VIEW_EDIT_DRIVER = 'driver';
  public static ADD_TRUCK = 'add-truck';
  public static VIEW_EDIT_TRUCK = 'truck';
  public static CONTRACTS_PATH = 'contracts';
  public static ADD_CONTRACT_PATH = 'add-contract';
  public static REPORTS_PATH = 'reports';
  public static NAVIGATION_KEY_G2G_INTEGRATION = 'G2G_INTEGRATION';
  public static NAVIGATION_KEY_G2G_REPORT = 'G2G';
  public static TRUCKS_REPORT_PATH = 'trucks-report';
  public static TRUCKS_REPORT_DETAILS = 'trucks-report-details';
  public static LEADS_PATH = 'leads';
  public static LIVE_TRACKING_PATH = 'live-tracking';
  public static INVOICES_PATH = 'invoices';
  public static TRANSACTIONS_PATH = 'transactions';
  public static DELIVERY_NOTES_PATH = 'delivery-notes';
  public static PUBLIC_PATH = 'public';
  public static PUBLIC_SHIPMENT_TRACKING_PATH = 'shipment-tracking';
  public static ACCESS_DENIED = 'access-denied';
  public static PUBLIC_REGISTRATION_PATH = 'registration';
  public static SETTINGS_PATH = 'settings';
  public static NAVIGATION_KEY_TRUCK_UTILIZATION_REPORT = 'TRUCK_UTILIZATION_REPORT';
  public static NAVIGATION_KEY_LOGS = 'LOGS';
  public static NAVIGATION_KEY_LOGS_WCC = 'LOGS_WCC';
  public static LOGS_PATH = 'logs';

  //customer-fleet-contract
  public static ADD_CUSTOMER_FLEET_CONTRACT_PATH = 'add-customer-fleet-contract';
  public static EDIT_CUSTOMER_FLEET_CONTRACT_PATH = 'edit-customer-fleet-contract';
  public static ADD_CUSTOMER_FLEET_TRADE_LANE_PATH = 'add-customer-fleet-contract-trade-lane';
  public static EDIT_CUSTOMER_FLEET_TRADE_LANE_PATH = 'edit-customer-fleet-contract-trade-lane';
  public static CUSTOMER_FLEET_CONTRACT_DETAILS_PATH = 'customer-fleet-contract-details';
  public static CUSTOMER_FLEET_CONTRACT_LIST_PATH = 'customer-fleet-contract-list';
  public static MADAR_CONTRACT_LIST_PATH = 'madar-contract-list';
}
